import { useState as o, useRef as b, useCallback as l, useEffect as m } from "react";
function S(u, c) {
  const [e, f] = o(u), [r, s] = o(u), n = b(null), a = !Object.is(e, r), t = l(() => {
    n.current && (clearTimeout(n.current), n.current = null);
  }, []), i = l(() => {
    t(), s(e);
  }, [e, t]);
  return m(() => (t(), n.current = setTimeout(() => {
    s(e), n.current = null;
  }, c), t), [e, c, t]), { state: e, debouncedState: r, isPending: a, setState: f, flush: i, cancel: t };
}
export {
  S as useDebouncedState
};
